// extracted by mini-css-extract-plugin
export default {"container":"q0s1q6","wrap":"rcYZMw"};